<template>
  <div class="page-wrapper">
    <!-- ===================== PC 版（折叠搜索栏） ===================== -->
    <div class="pc-version">
      <div
        class="user-level-table-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- PC 搜索栏（折叠版） -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <div class="search-collapse-btn" @click="toggleSearch">
            <i
              class="el-icon-arrow-down"
              :class="{ 'el-icon-arrow-up': !searchCollapsed }"
            ></i>
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </div>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              gap: '10px',
              alignItems: 'center',
            }"
          >
            <el-select
              v-model="searchParams.level_id"
              placeholder="请选择等级"
              clearable
              style="width: 200px"
            >
              <el-option
                v-for="item in levelOptions"
                :key="item.level_id"
                :label="item.name"
                :value="item.level_id"
              ></el-option>
            </el-select>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </div>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="等级编号"
            prop="level_id"
            width="120"
            align="center"
          />
          <el-table-column label="等级名称" prop="name" min-width="150" />
          <el-table-column
            label="累计消费金额"
            prop="total_pay"
            width="160"
            align="center"
          />
          <el-table-column
            label="奖励数值"
            prop="reward_value"
            width="120"
            align="center"
          />
          <el-table-column label="等级图标" width="140" align="center">
            <template slot-scope="scope">
              <img
                v-if="scope.row.image"
                :src="scope.row.image"
                style="width: 40px; height: 40px; object-fit: cover"
              />
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <el-dialog
          title="等级详情"
          :visible.sync="detailVisible"
          width="500px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="100px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="等级编号"
              ><span>{{ detailForm.level_id }}</span></el-form-item
            >
            <el-form-item label="等级名称"
              ><span>{{ detailForm.name }}</span></el-form-item
            >
            <el-form-item label="累计消费"
              ><span>{{ detailForm.total_pay }}</span></el-form-item
            >
            <el-form-item label="奖励数值"
              ><span>{{ detailForm.reward_value }}</span></el-form-item
            >
            <el-form-item label="等级图标">
              <img
                v-if="detailForm.image"
                :src="detailForm.image"
                style="width: 60px; height: 60px"
              />
              <span v-else>无</span>
            </el-form-item>
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ===================== 移动端（折叠搜索栏） ===================== -->
    <div class="mobile-version">
      <div
        class="mobile-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 移动端搜索栏（折叠版） -->
        <div class="mobile-search">
          <div class="mobile-search-collapse" @click="toggleSearch">
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </div>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-select
              v-model="searchParams.level_id"
              placeholder="选择等级"
              clearable
              size="medium"
            ></el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              style="flex: 1"
              @click="getList"
              >搜索</el-button
            >
            <el-button plain round style="flex: 1" @click="resetSearch"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleRowClickMobile(item)"
          >
            <div class="card-top">
              <div class="label">{{ item.name }}</div>
              <div class="tag">Lv{{ item.level_id }}</div>
            </div>
            <div class="card-body">
              <div><span>ID：</span>{{ item.id }}</div>
              <div><span>累计消费：</span>{{ item.total_pay }} 元</div>
              <div><span>奖励：</span>{{ item.reward_value }}</div>
              <div style="display: flex; align-items: center; gap: 8px">
                <span>图标：</span>
                <img
                  v-if="item.image"
                  :src="item.image"
                  style="width: 36px; height: 36px; object-fit: cover"
                />
                <span v-else>无</span>
              </div>
            </div>
            <div class="card-footer">
              <div>创建：{{ item.created_at }}</div>
              <div>更新：{{ item.updated_at }}</div>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="prev, pager, next, total"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <el-dialog
          title="等级详情"
          :visible.sync="detailVisibleMobile"
          width="90%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form :model="detailForm" label-width="90px" size="small">
            <el-form-item label="ID"
              ><span>{{ detailForm.id }}</span></el-form-item
            >
            <el-form-item label="等级编号"
              ><span>{{ detailForm.level_id }}</span></el-form-item
            >
            <el-form-item label="等级名称"
              ><span>{{ detailForm.name }}</span></el-form-item
            >
            <el-form-item label="累计消费"
              ><span>{{ detailForm.total_pay }}</span></el-form-item
            >
            <el-form-item label="奖励数值"
              ><span>{{ detailForm.reward_value }}</span></el-form-item
            >
            <el-form-item label="等级图标">
              <img
                v-if="detailForm.image"
                :src="detailForm.image"
                style="width: 60px; height: 60px"
              />
              <span v-else>无</span>
            </el-form-item>
            <el-form-item label="创建时间"
              ><span>{{ detailForm.created_at }}</span></el-form-item
            >
            <el-form-item label="更新时间"
              ><span>{{ detailForm.updated_at }}</span></el-form-item
            >
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserLevelList",
  data() {
    return {
      loading: false,
      tableData: [],
      levelOptions: [],
      total: 0,
      searchParams: { page: 1, page_size: 10, level_id: "" },
      detailVisible: false,
      detailForm: {},
      detailVisibleMobile: false,
      // 新增：搜索栏折叠状态
      searchCollapsed: true,
    };
  },
  created() {
    this.getAllLevels();
    this.getList();
  },
  methods: {
    async getAllLevels() {
      try {
        const res = await api.users.getUserLevelList({
          params: { page: 1, page_size: 9999 },
        });
        if (res.data.code == 1000) {
          this.levelOptions = res.data.data.data.map((item) => ({
            level_id: item.level_id,
            name: item.name,
          }));
        }
      } catch (e) {}
    },
    async getList() {
      this.loading = true;
      try {
        const res = await api.users.getUserLevelList({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
      } finally {
        this.loading = false;
      }
    },
    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },
    handleRowClickMobile(row) {
      this.detailForm = { ...row };
      this.detailVisibleMobile = true;
    },
    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, level_id: "" };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    // 新增：切换搜索栏折叠
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
.user-level-table-container {
  padding: 20px;
}
.mobile-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 16px;
  font-weight: 500;
}
.card-top .tag {
  background: #e8f3ff;
  color: #409eff;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.card-body span {
  color: #999;
}
.card-footer {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userLevel.vue